<script>
	import Chart from 'chart.js'
	import {Pie, mixins as pieChartMixins } from 'vue-chartjs';
	const { reactiveProp } = pieChartMixins;
	Chart.defaults.global.elements.arc.borderWidth = 3;
	export default {
		name: "PieChart",
		extends: Pie,
        mixins: [reactiveProp],
        props:['options'],
		data() {
			return {
			}
		},
		mounted() {
			this.renderChart(this.chartData, this.options);
		}
	}
</script>

<style scoped>

</style>
